import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
import { getDefaultProperties, getDerivedOutputMetadata, getVerifyOutputs } from './lib/index.js';
import { PRODUCTS } from '@atomicfi/constants-shared';
export const createTaskStatusPatchedSamplePayload = ({ product = PRODUCTS.DEPOSIT, data = {} } = {}) => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.TASK_STATUS_PATCHED,
        ...getDefaultProperties(),
        product,
        data: {
            authenticated: true,
            ...data,
            ...(product === 'verify'
                ? {
                    outputs: getVerifyOutputs(),
                    derivedOutputMetadata: getDerivedOutputMetadata()
                }
                : {})
        }
    };
};
//# sourceMappingURL=task-status-patched.js.map